import React from "react";
import {
  Box,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell as MuiTableCell,
  TableBody,
  Paper,
  Typography,
  styled,
  Stack,
} from "@mui/material";

type Patent = {
  srNo: number;
  titleOfInvention: string;
  nameOfInventor: string;
  applicationNo: string;
  publicationDate: string;
  internationalClassification: string;
  department: string;
};

const patentData: Patent[] = [
  {
    srNo: 1,
    titleOfInvention: "Pressure capsule gauge",
    nameOfInventor: "Dr Swathi Sundarajan, Dr Gauri Afle, Dr Abhijit Satralkar, Dr Vishvanath Pawadshetty",
    applicationNo: "410438-001",
    publicationDate: "03-05-2024",
    internationalClassification: "",
    department: "Department Of Cardiovascular & Respiratory PT"
  },
  {
    srNo: 2,
    titleOfInvention: "Solar Cardiorespiratory recovery belt",
    nameOfInventor: "Dr Vishvanath Pawadshetty, Dr Gauri Afle, Dr Sandesh Londhe, Dr Ravina R Rohane, Dr Pritesh Yeole, Dr Rakesh Jadhav, Dr Akankasha Chauhan, Dr Kaneez Fatema, Dr UmaDevi Pawadshetti, Dr Shruti Pavshere",
    applicationNo: "398091-001",
    publicationDate: "19-12-2023",
    internationalClassification: "",
    department: "Department Of Cardiovascular & Respiratory PT"
  }
];

const TableCell = styled(MuiTableCell)(({ theme }) => ({
  fontSize: 14,
  textAlign: "left",
  color: theme.palette.primary.contrastText,
}));

function InnovationsRegisteredPatents() {
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
        spacing={2}
      >
        <Typography
          variant="h6"
          sx={{
            p: 2,
            backgroundColor: "primary.main",
            color: "white",
            width: "100%",
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          Innovations & Registered Patents
        </Typography>
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">Sr. No</TableCell>
                <TableCell align="center">Title of Invention</TableCell>
                <TableCell align="center">Name of Inventor</TableCell>
                <TableCell align="center">Application No</TableCell>
                <TableCell align="center">Publication Date</TableCell>
                <TableCell align="center">
                  International Classification
                </TableCell>
                <TableCell align="center">Department</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {patentData?.length > 0 ? (
                patentData?.map((item) => (
                  <TableRow key={item.srNo}>
                    <TableCell align="center">{item.srNo}</TableCell>
                    <TableCell align="center">
                      {item.titleOfInvention}
                    </TableCell>
                    <TableCell align="center">
                      {item.nameOfInventor.split(", ").map((name, index) => (
                        <Typography key={index} variant="body2" sx={{ fontSize: 14 }}>
                          {name}
                        </Typography>
                      ))}
                    </TableCell>
                    <TableCell align="center">{item.applicationNo}</TableCell>
                    <TableCell align="center">{item.publicationDate}</TableCell>
                    <TableCell align="center">
                      {item.internationalClassification}
                    </TableCell>
                    <TableCell align="center">{item.department}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow sx={{ textAlign: "center" }}>
                  <TableCell
                    colSpan={7}
                    align="center"
                    style={{ textAlign: "center" }}
                  >
                    {"No data Found!"}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </Box>
  );
}

export default InnovationsRegisteredPatents;
